import React from 'react'
import clsx from 'clsx'

export interface TabOption<T extends string = string> {
  key: T
  title: string
  icon?: string
}

interface TabHeaderProps<T extends string = string> {
  formId: string
  isVisibleResetButton?: boolean
  isVisibleSubmitButton?: boolean
  isVisibleExportButton?: boolean
  formikSubmit: () => void
  formikReset: () => void
  loading: boolean
  tab: string
  setTab: (tab: string) => void
  setSelectedId: (id: string | null) => void
  tabs: TabOption<T>[]
  onExportExcel: () => void
  smallButton?: boolean
}

const FormTabHeader: React.FC<TabHeaderProps> = ({
  formId,
  isVisibleResetButton = true,
  isVisibleSubmitButton = true,
  isVisibleExportButton = true,
  formikSubmit,
  formikReset,
  loading,
  tab,
  setTab,
  setSelectedId,
  tabs,
  onExportExcel,
  smallButton = false,
}) => {
  return (
    <div className='d-flex justify-content-between align-items-center mb-5 flex-wrap gap-3'>
      {/* Sol taraf - Tab butonları */}
      <div className='d-flex flex-wrap gap-1'>
        {tabs.map((t) => (
          <button
            key={t.key}
            type='button'
            className={clsx('btn btn-sm', tab === t.key ? 'btn-primary' : 'btn-light')}
            onClick={() => setTab(t.key)}
          >
            {t.icon && <i className={`${t.icon} me-2`}></i>}
            {t.title}
          </button>
        ))}
      </div>

      {/* Sağ taraf - Aksiyon butonları */}
      <div className='d-flex flex-wrap gap-1 ms-auto'>
        {/* Yeni Buton - Mavi */}
        {isVisibleResetButton && (
          <button
            type='button'
            className='btn btn-sm btn-primary d-flex align-items-center justify-content-center'
            onClick={formikReset}
            title='Yeni Kayıt'
          >
            <i className={`bi bi-plus-circle fs-5 ${!smallButton ? 'me-1' : ''}`}></i>
            {!smallButton && <span>Yeni</span>}
          </button>
        )}

        {/* Kaydet Buton - Yeşil */}
        {isVisibleSubmitButton && (
          <button
            type='button'
            aria-controls={formId}
            className='btn btn-sm btn-success d-flex align-items-center justify-content-center'
            onClick={() => formikSubmit()}
            disabled={loading}
          title={loading ? 'Kaydediliyor...' : 'Kaydet'}
        >
          {loading ? (
            <>
              <span
                className={`spinner-border spinner-border-sm ${!smallButton ? 'me-1' : ''}`}
                role='status'
                aria-hidden='true'
              ></span>
              {!smallButton && 'Kaydediliyor...'}
            </>
          ) : (
            <>
              <i className={`bi bi-check-circle fs-5 ${!smallButton ? 'me-1' : ''}`}></i>
              {!smallButton && <span>Kaydet</span>}
            </>
          )}
        </button>)}

        {/* Excel Aktar Buton - Koyu Yeşil */}
        {isVisibleExportButton && (
          <button
            type='button'
            className='btn btn-sm btn-success d-flex align-items-center justify-content-center'
            onClick={onExportExcel}
            title="Excel'e Aktar"
            style={{backgroundColor: '#217346', borderColor: '#217346'}}
          >
            <i className={`bi bi-file-earmark-spreadsheet fs-5 ${!smallButton ? 'me-1' : ''}`}></i>
            {!smallButton && <span>Excel'e Aktar</span>}
          </button>
        )}
      </div>
    </div>
  )
}

export default FormTabHeader
